<template>
  <div class="section section-basic">
    <div class="container">
      <div class="row">
        <div class="col-sm-4 col-lg-3">
          <p class="category">Categories</p>
          <div class="checkbox" v-for="category in categories" :key="category.id">
            <input
              :id="`category-${category.id}`"
              type="checkbox"
              :value="category.id"
              v-model="selectedCategories"
            />
            <label :for="`category-${category.id}`">
              <span class="badge badge-warning">{{ category.equipments.length }}</span>
              {{ category.name }}
            </label>
          </div>
        </div>
        <div class="col-sm-8 col-lg-9">
          <p class="category">Browse our Inventory</p>
          <!-- <div v-show="loadingItems" class="text-center">
                        <h3>
                            <i class="now-ui-icons loader_refresh spin"></i>
                            Loading Inventory...
                        </h3>
          </div>-->
          <div class="row">
            <div class="col-sm-6 col-lg-4" v-for="item in pagedItems" :key="item.id">
              <inventory-item :equipment="item"></inventory-item>
            </div>
          </div>

          <div class="text-center">
            <button
              class="btn btn-primary btn-simple btn-round"
              v-show="more"
              @click="pages++"
            >Load more...</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import _ from "lodash";
import gql from "graphql-tag";
import InventoryItem from "./InventoryItem";
export default {
  components: { InventoryItem },
  props: {
    alt: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      selectedCategories: [],
      pages: 1,
      result: {}
    };
  },
  computed: {
    perPage() {
      return this.alt ? 3 : 9;
    },
    limit() {
      return this.perPage * this.pages;
    },
    more() {
      return this.items.length > this.limit;
    },
    categories() {
      return _.filter(this.result.categories, c => !!c.equipments.length);
    },
    items() {
      return _.chain(this.result.equipments)
        .filter(
          ({ category: { id } }) => _.indexOf(this.selectedCategories, id) != -1
        )
        .value();
    },
    pagedItems() {
      return _.take(this.items, this.limit);
    }
  },
  watch: {
    selectedCategories: function() {
      this.pages = 1;
    }
  },
  async mounted() {
    ({ data: this.result } = await this.$apollo.query({
      query: gql`
        {
          categories(orderBy: name_ASC, stage: PUBLISHED) {
            id
            name
            equipments {
              id
            }
          }

          equipments(where: {category: {id_not: null}}, stage: PUBLISHED) {
            id
            title
            content
            category {
              id
            }
            images {
              id
              url
            }
          }
        }
      `
    }));
    this.selectedCategories = _.map(this.result.categories, "id");
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Inventory.vue